import WithdrawalPayoutForm from "./WithdrawalPayoutForm";

const PayoutTab = () => <WithdrawalPayoutForm />;

export default PayoutTab;
